import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function Eshramservice() {
  

  return (
    <>
      <Header/>

      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <h1 className="text-white">E-shram</h1>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light rounded-pill"
              >
                SERVICES
              </button>
            </div>
            <h1 style={{ textAlign: 'center' }}>
              <span>E-shram card</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <section id="about" className="about section light-background">
        <div className="container">
          <div className="row">

            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
              <div className="about-content ps-0 ps-lg-3">
                {/* <h3>"Innovation is not just our Strength; it is our Foundation."</h3> */}
                <p className="fst-italic">
                  <b>Sai Financial Service</b> Provider acts as a facilitator for E-Shram card registration and does not issue E-Shram cards. The final approval and issuance rest with the Ministry of Labour and Employment.

                </p>
                <h3>Services terms&conditions:</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Service Fee Policy:</b> The ₹50 service charge is non-refundable, even if the application is delayed or rejected due to inaccuracies or incomplete information provided by the applicant.</p></li>
                  <li><p className="fst-italic"><b>Documentation Responsibility:</b> The applicant must provide all required documents as per the guidelines issued by the Ministry of Labour and Employment.</p></li>
                  <li><p className="fst-italic"><b>Government Fees:</b> Any additional fees mandated by the government (if applicable) must be borne by the applicant and are not included in the service charge.</p></li>
                  <li><p className="fst-italic"><b>Accuracy of Information:
                  </b>The applicant is responsible for providing accurate and complete details. Sai Financial Service Provider is not liable for delays or rejections caused by errors in the provided information.</p></li>
                  <li><p className="fst-italic"><b>Processing Time:</b>Standard processing times apply. Delays may occur due to verification procedures by the government authorities.</p></li>

                  {/* <li><p className="fst-italic"><b>Vehicle Loans:</b>This service is available for all major credit card networks, including Visa, MasterCard, and RuPay.</p></li>
                                    <li><p className="fst-italic"><b>Loan Against Property:</b>  Unlock the potential of your property to get funds for your business or personal needs.</p></li>
                                    <li><p className="fst-italic"><b>Others Loan:</b> We also provide other loan services like education loans, gold loans, agricultural loans and other loans designed to meet specific financial requirements.</p></li> */}
                </ol>
                <h3>Why Choose Us?</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Wide Network of Lenders:</b> We have partnerships with all major banks and financial institutions, allowing us to find the right loan offer for you.</p></li>
                  <li><p className="fst-italic"><b>Expert Guidance:</b> Our team of loan experts helps you throughout the loan process, from application to disbursement.</p></li>
                  <li><p className="fst-italic"><b>Customized Solutions:</b> Based on your needs and financial situation, we offer tailored loan solutions with competitive interest rates.</p></li>
                </ol>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
              <img src="assets\images\svg\e-shrem.jpg" alt className="h-100 p-2 img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">

            <h1 style={{ textAlign: 'center' }}>
              <span>E-sharm card</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <Servicedata/>
      <Footer />
    </>
  )
}

export default Eshramservice

